import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import Typography from '@digital-hig/mui/dist/Typography';
import Button from '@mui/material/Button';
import SvgIcon from '@mui/material/SvgIcon';
import SvgCtaArrowRight from '@digital-hig/icon/lib/esm/icons/cta-arrow-right';
// import SvgCtaArrowRight from '@digital-hig/icon/lib/esm/icons/cta-arrow-right-solid';
import DOMPurify from 'isomorphic-dompurify';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Card from '@digital-hig/mui/dist/Card';
import CardMedia from '@mui/material/CardMedia';
import { triggerManualLinkClick } from '../common/analyticsApi';
import {
  EDC_SLUG_AEC_INDUSTRY_BLOCK,
  EDC_SLUG_MFG_INDUSTRY_BLOCK,
  EDC_SLUG_MEDIA_AND_ENTERTAINMENT_INDUSTRY_BLOCK,
  EDC_SLUG_EDUCATION_INDUSTRY_BLOCK,
  EDC_SLUG_EARN_AN_AUTODESK_CERT_BLOCK,
} from '../common/constants';

const DiscoverIndustriesPanels = ({
  indexData = {}, industrySubSegments = [],
}) => {
  const industryEdcBlocks = [
    { editorial: EDC_SLUG_AEC_INDUSTRY_BLOCK, industry: 'AEC', tagData: 'irlcp - explore the aec catalog' },
    { editorial: EDC_SLUG_MFG_INDUSTRY_BLOCK, industry: 'MFG', tagData: 'irlcp - explore the mfg catalog' },
    { editorial: EDC_SLUG_MEDIA_AND_ENTERTAINMENT_INDUSTRY_BLOCK, industry: 'M&E', tagData: 'irlcp - explore the m&e catalog' },
    { editorial: EDC_SLUG_EDUCATION_INDUSTRY_BLOCK, industry: 'EDU', tagData: 'irlcp - explore the edu catalog' },
  ];

  const getCurIndSubSegments = (curIndustry) => {
    const subSegments = industrySubSegments.filter((subseg) => subseg.parent === curIndustry).map((indSeg) => indSeg.value).join(',');

    return subSegments;
  };

  const handleLinkClickTag = (title) => {
    triggerManualLinkClick({
      linkTitle: title,
    });
  };

  return (
    <RootElement>
      <div className="maxWidth">
        <Grid container>
          <Grid xs={12}>
            <Typography className="maxWidth title" variant="headline-medium">Discover industry relevant learning</Typography>
          </Grid>
          <div className="indstry-panel-wrapper">
            <div className="industry-panels-container">
              {Object.keys(indexData).length ? (
                industryEdcBlocks.map((industryEdc) => (
                  indexData[industryEdc.editorial] && Object.keys(indexData[industryEdc.editorial]).length !== 0 && (
                    <div>

                      <CardActionArea
                        component={Link}
                        to={`${indexData[industryEdc.editorial]?.linkUrl}${getCurIndSubSegments(industryEdc.industry)}`}
                        className="industry-card"
                        onClick={() => handleLinkClickTag(industryEdc.tagData)}
                      >
                        <Card>
                          <CardMedia
                            alt={industryEdc.editorial}
                            component="img"
                            image={indexData[industryEdc.editorial]?.image}
                          />
                          <CardContent>
                            <Typography component="div" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(indexData[industryEdc.editorial]?.content) }} />
                          </CardContent>
                          <CardActions sx={{ mt: 6 }}>
                            <Button
                              className="panel-cta"
                              startIcon={(
                                <>
                                  <SvgIcon fontSize="medium"><SvgCtaArrowRight /></SvgIcon>
                                </>
                              )}
                              variant="link-button"
                            >
                              {indexData[industryEdc.editorial]?.linkText}
                            </Button>
                          </CardActions>
                        </Card>
                      </CardActionArea>
                    </div>
                  )
                ))
              ) : <></>}
            </div>
          </div>
        </Grid>
      </div>
      <div className="introParagraph">
        <div className="maxWidth">
          <Grid container className="autodesk-cert-prep">
            <Grid lg={6} md={12}>
              <img className="thumbnail" src={indexData[EDC_SLUG_EARN_AN_AUTODESK_CERT_BLOCK]?.image} alt="Earn an Autodesk Certification" />
            </Grid>
            <Grid lg={6} md={12} className="right-column">
              <Typography component="div" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(indexData[EDC_SLUG_EARN_AN_AUTODESK_CERT_BLOCK]?.content) }} />
              <Button
                component={Link}
                to={indexData[EDC_SLUG_EARN_AN_AUTODESK_CERT_BLOCK]?.secondaryLinkUrl}
                variant="outlined"
                onClick={() => handleLinkClickTag('irlcp - browse prep courses')}
              >
                {indexData[EDC_SLUG_EARN_AN_AUTODESK_CERT_BLOCK]?.secondaryLinkText}
              </Button>
              <Button
                href={indexData[EDC_SLUG_EARN_AN_AUTODESK_CERT_BLOCK]?.linkUrl}
                variant="link-button"
                startIcon={(
                  <>
                    <SvgIcon fontSize="medium"><SvgCtaArrowRight /></SvgIcon>
                    {/* <SvgIcon fontSize="medium"><SvgCtaArrowRightSolid /></SvgIcon> */}
                  </>
                )}
                onClick={() => handleLinkClickTag('irlcp - explore certifications')}
              >
                {indexData[EDC_SLUG_EARN_AN_AUTODESK_CERT_BLOCK]?.linkText}
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    </RootElement>
  );
};

const RootElement = styled.div`
   p.maxWidth.title {
    padding-left: 0;
   }
   .indstry-panel-wrapper {
      .industry-panels-container{
        width: fit-content;
        display: flex;
        flex-wrap: nowrap;
        gap: 20px;
        margin-top: 40px;
        margin-bottom: 40px;

        div:nth-child(3), div:nth-child(4){
          a {
            .MuiCardActions-spacing{
              margin-top: 55px;
            }
          }
        }
        a.industry-card{
          height: 100%;
          > div{
            height: 100%;
          }
          }
          }
      button.panel-cta{
        font-size: 14px;
        align-items: center;
        
        &:active{
          font-size: 14px;
        }
        > span {
          svg {
            outline: none;
          }
        }
      }
        h3 {
          margin-top: -6px;
        }
      }

      .autodesk-cert-prep{
        margin-top: 30px;
        display: flex;
        align-items: center;
        gap: 40px;
        flex-wrap: nowrap;
        jusify-content: space-between;

        .thumbnail {
          width: 100%;
        }
        .right-column {
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          a{
            margin-bottom: 12px;
          }
      }
    }

 @media only screen and (max-width: 1039px) {
        p.maxWidth.title {
          padding-left: 1.5rem;
        }
        > .maxWidth {
          padding-left: 0;
          padding-right: 0;
        }
        .autodesk-cert-prep{
            flex-wrap: wrap   ; 
          }
       .indstry-panel-wrapper {
            overflow: scroll hidden;
            scrollbar-width: none;
            padding: 0;
          
            .industry-panels-container{
             > div: first-child{
            padding-left: 1.5rem;
          }
            > div: last-child{
            padding-right: 1.5rem;
          }
              > div {
                min-width: 298px;
              }
            }
          }
}
 
`;

DiscoverIndustriesPanels.propTypes = {
  indexData: PropTypes.objectOf({}).isRequired,
  industrySubSegments: PropTypes.arrayOf().isRequired,
};

export default React.memo(DiscoverIndustriesPanels);
